module.exports = __webpack_public_path__ + "static/media/liechtenstein.6a4c8055.png";